<template>
  <div class='istest'>
    <div class="title">
      <span>{{title}}</span>
      <button @click="$emit('gocourse',catId)">返回课程主页</button>
    </div>
    <div class="content">
      <h2>测试说明：</h2>
      <div class="info">
        {{testInfo}}
      </div>
      <button
        v-if="isFinished"
        class="testbtn"
        @click="$emit('seetest',paperId,catId,menuId,title,chapterId)"
      >
        查看成绩
      </button>
      <button
        v-else
        class="testbtn"
        @click="$emit('totest',paperId,catId,menuId,title,chapterId)"
      >
        开始测试
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "istest",
  props: {
    resourceUrl: String,
    title: String,
    testInfo: String,
    paperId: [String, Number],
    catId: [String, Number],
    menuId: [String, Number],
    isFinished: Boolean,
    joined:Boolean,
    chapterId:[String,Number]
  },
};
</script>

<style lang="stylus" scoped>
.istest {
  .title {
    height: 65px;
    border-bottom: 1px solid #eee;
    margin-left: 38px;
    margin-right: 39px;
    display: flex;
    position: relative;

    span {
      color: #333333;
      font-size: 18px;
      padding-top: 30px;
    }

    button {
      border: 0;
      outline: none;
      width: 99px;
      height: 30px;
      background-color: #ffffff;
      border: solid 1px #cecece;
      color: #ef9545;
      font-size: 14px;
      position: absolute;
      right: 17px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .content {
    margin: 0 auto;
    margin-top: 24px;
    margin-left: 33px;
    margin-right: 120px;
    margin-bottom: 50px;
    overflow: hidden;
    min-height: 700px;

    h2 {
      color: #333;
      font-size: 16px;
      margin-bottom: 25px;
      font-weight: bold;
    }

    .info {
      color: #666;
      font-size: 14px;
      margin-bottom: 47px;
    }

    .testbtn {
      width: 120px;
      height: 46px;
      background-color: #f0cd48;
      color: #333;
      font-size: 16px;
      border: 0;
      // border-radius: 3px;
      outline: none;
    }
  }
}
</style>
